<template>
  <div class="out-warp">
    <div class="s-filter-box no-title">
      <a-space>
        <a-button
          :disabled="loadStatus || messageItems.length > 0"
          :loading="saveLoading"
          @click="save()"
        >
          <template #icon>
            <SaveOutlined />
          </template>
          save
        </a-button>
        <a-button :disabled="loadStatus" @click="deleteTable()">
          <template #icon><delete-outlined /></template>
          Delete
        </a-button>
      </a-space>

      <div class="btn-right">
        <a-button type="link" @click="openAddListModal()">
          Work Order Insert
        </a-button>
        <a-divider type="vertical"></a-divider>
        <a-button type="link" download="uploadFormat.xlsx" :href="downloadUrl">
          Download file Format
        </a-button>
      </div>
    </div>
    <div class="up-content">
      <div class="upload-box" v-if="loadStatus">
        <a-upload
          accep=".xml,.xmls"
          :maxCount="1"
          :file-list="fileList"
          :before-upload="beforeUpload"
          @remove="handleRemove"
        >
          <a-button>
            <upload-outlined></upload-outlined>
            Select File
          </a-button>
        </a-upload>
        <a-button
          type="primary"
          :disabled="fileList.length === 0"
          :loading="uploading"
          style="margin-top: 16px"
          @click="handleUpload"
        >
          {{ uploading ? 'Uploading' : 'Start Upload' }}
        </a-button>
        <div class="b-b">
          <a-button
            :loading="importShipmentLoading"
            type="link"
            @click="importShipmentData"
          >
            Import Data from Shipment Window
          </a-button>
        </div>
      </div>
      <div v-else class="table-box-up" ref="tableBoxRef">
        <a-table
          :columns="columns"
          :row-key="(record) => record.id"
          :data-source="upItems"
          :pagination="{ defaultPageSize: 20 }"
          :scroll="{ y: tableYHeight }"
          :row-class-name="rowClassName"
          :customRow="rowClick"
          size="small"
        ></a-table>
      </div>
    </div>
    <WorkOrderInset
      :is-open="woInsetVis"
      :fg-name-list="fgNameList"
      @onModalClose="woInsetVis = false"
    ></WorkOrderInset>
  </div>
</template>
<script setup>
  import { baseURL } from '@/config'
  import { ref, computed, onMounted, h } from 'vue'
  import { throttle } from '@/utils'
  import { message, Modal } from 'ant-design-vue'
  import { useStore } from 'vuex'
  import request from '@/utils/request'
  import WorkOrderInset from './components/work-order-inset.vue'
  import Storage from 'good-storage'
  import dayjs from 'dayjs'
  import {
    SaveOutlined,
    DeleteOutlined,
    UploadOutlined,
  } from '@ant-design/icons-vue'

  const loadStatus = ref(Storage.get('scheduling-upItems') ? false : true)
  const messageItems = ref(Storage.get('scheduling-message') || [])
  const upItems = ref(Storage.get('scheduling-upItems') || [])
  const store = useStore()
  const netGroup = computed(() => store.getters['user/currentNetGroup'])
  const currentSystem = computed(() => store.getters['user/currentSystem'])
  const downloadUrl = `${baseURL}/export/${currentSystem.value}/uploadFormat.xlsx`
  const fileList = ref([])
  const uploading = ref(false)
  const handleRemove = () => {
    fileList.value = []
  }

  const fgNameList = ref([])
  const getFgNameList = () => {
    return new Promise((resolve, reject) => {
      request({
        url: 'api/masterdata/queryFGs',
        params: {
          netGroupId: netGroup.value,
        },
      })
        .then((res) => {
          fgNameList.value = [...new Set(res.body)]
          resolve()
        })
        .catch((e) => {
          reject(e)
        })
    })
  }

  const beforeUpload = (file) => {
    fileList.value = [file]
    return false
  }
  const handleUpload = () => {
    const formData = new FormData()

    formData.append('file', fileList.value[0])

    uploading.value = true // You can use any AJAX library you like

    request({
      url: '/api/schedule/uploadOrderMain',
      nonstandard: true,
      headers: {
        'Content-Type': undefined,
      },
      method: 'post',
      data: formData,
    })
      .then(async (res) => {
        fileList.value = []
        await _successCallback(res, 0)
        uploading.value = false
      })
      .catch(() => {
        uploading.value = false
      })
  }
  // 删除
  const deleteTable = () => {
    Modal.confirm({
      title: 'Deleted file',
      content: 'Are you sure you want to delete this document?',
      onOk() {
        clearDate()
      },
    })
  }
  const clearDate = () => {
    upItems.value = ''
    messageItems.value = ''
    loadStatus.value = true
    Storage.remove('scheduling-upItems')
    Storage.remove('scheduling-message')
    Storage.remove('scheduling-uploadForm')
  }
  // 保存
  const saveLoading = ref(false)
  const save = () => {
    saveLoading.value = true
    let batchUploadId = { batchUploadId: upItems.value[0].batchUploadId }
    let n = Storage.get('scheduling-uploadForm')
    let url =
      n === 0 ? '/api/schedule/saveUpload' : '/api/shipment/saveWorderMain'
    request({
      url: url,
      method: 'post',
      data: batchUploadId,
    })
      .then(() => {
        message.success('Upload Success!!!').then(() => {
          clearDate()
        })
      })
      .finally(() => {
        saveLoading.value = false
      })
  }
  // 打开弹窗
  const woInsetVis = ref(false)
  const openAddListModal = async () => {
    const hide = message.loading('Loading……', 0)
    await getFgNameList()
    woInsetVis.value = true
    hide()
  }
  // import shipment window
  const importShipmentLoading = ref(false)
  const importShipmentData = () => {
    importShipmentLoading.value = true
    request({
      url: '/api/shipment/importFromShipment',
      nonstandard: true,
      params: {
        netGrp: netGroup.value,
      },
    })
      .then(async (res) => {
        await _successCallback(res, 1)
      })
      .finally(() => {
        importShipmentLoading.value = false
      })
  }
  const _successCallback = (response, n) => {
    return new Promise((resolve) => {
      if (response.errCode === '0000') {
        if (response.body.length == 0) {
          //如果内容为空，不继续执行后面代码

          message.info('No Data!!!')
          return
        }
        loadStatus.value = false
        upItems.value = response.body
        messageItems.value = response.body.filter(
          (item) => item.uploadStatus === 1
        )

        message.success('upload successfully.')
        Storage.set('scheduling-upItems', upItems.value)
        Storage.set('scheduling-message', messageItems.value)
        Storage.set('scheduling-uploadForm', n)
      } else {
        loadStatus.value = true
        message.error(response.errMsg)
      }
      resolve()
    })
  }
  const tableYHeight = ref(300)
  const tableBoxRef = ref(null)
  const setTableScrollH = () => {
    if (!tableBoxRef.value) return
    const tableHeader = document.querySelector('.ant-table-header')
    const tHeadHeight = tableHeader ? tableHeader.clientHeight : 44

    const tablePag = document.querySelector('.ant-pagination')
    const tablePagHeight = tablePag ? tablePag.clientHeight + 30 : 60

    tableYHeight.value =
      tableBoxRef.value.clientHeight - tHeadHeight - tablePagHeight
  }
  onMounted(() => {
    setTimeout(setTableScrollH, 2000)
    window.addEventListener('resize', throttle(setTableScrollH, 500))
  })
  const rowClassName = (record, index) => {
    if (record.uploadStatus === 1 && index % 2 === 1) {
      return 'error table-striped'
    } else if (index % 2 === 1) {
      return 'table-striped'
    } else if (record.uploadStatus === 1) {
      return 'error'
    } else {
      return null
    }
  }
  const rowClick = (record, index) => {
    return {
      onClick: () => {
        if (record.uploadStatus === 1) {
          let errorsHtml = []
          for (var i = 0; i < record.errors.length; i++) {
            errorsHtml.push(h('li', record.errors[i]))
          }
          Modal.error({
            title: `Error message(Line ${index + 1})`,
            content: h('ul', { class: 'm-ul' }, errorsHtml),
          })
        }
      },
    }
  }
  const columns = [
    {
      title: 'No',
      dataIndex: 'no',
      key: 'no',
      customRender({ index }) {
        return index + 1
      },
      width: '6%',
    },
    {
      title: 'Job ID',
      dataIndex: 'jobId',
      width: '10%',
    },
    {
      title: 'PO No',
      dataIndex: 'poNum',
      width: '10%',
    },
    {
      title: 'Country',
      dataIndex: 'country',
      width: '10%',
    },
    {
      title: 'FG Name',
      dataIndex: 'fgName',
      width: '10%',
    },
    {
      title: 'Priority',
      dataIndex: 'priority',
      width: '10%',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      width: '10%',
    },
    {
      title: 'ReqShip Date',
      dataIndex: 'reqShipDate',
      width: '12%',
      customRender({ text }) {
        return dayjs(text).format('YYYY-MM-DD')
      },
    },
    {
      title: 'Req End',
      dataIndex: 'reqEnd',
      width: '12%',
      customRender({ text }) {
        return dayjs(text).format('YYYY-MM-DD')
      },
    },
    {
      title: 'Batch ID',
      dataIndex: 'batchUploadId',
      width: '10%',
    },
  ]
</script>
<style lang="less" scoped>
  @import './less/scheduling.less';
  .out-warp {
    height: 100%;
  }
  .up-content {
    height: calc(100% - 54px);
    .table-box-up {
      height: 100%;
    }
  }
  .s-filter-box {
    padding: 10px;
    background: #f2f3f5;
    border-bottom: 1px solid #dbdcdc;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .b-b {
    padding-top: 20px;
    :deep(.ant-btn) {
      > span {
        text-decoration: underline;
      }
    }
  }
  :deep(.ant-table) {
    .table-striped {
      background: #fcfcfc;
    }
    .error {
      background: #fff0ed;
      td.ant-table-cell-row-hover {
        background: #fff0ed;
      }
    }
  }
</style>
<style lang="less">
  .ant-modal-body {
    .m-ul {
      margin: 0;
      padding: 10px 0;
      li {
        padding-left: 15px;
        position: relative;
        &::before {
          content: '';
          display: block;
          width: 4px;
          height: 4px;
          background: #ccc;
          position: absolute;
          left: 0;
          top: 50%;
          margin-top: -2px;
        }
      }
    }
  }
</style>
